export default __webpack_public_path__ + "static/media/moi.a1ddad1b.jpg";